// Enrolments that a crash or redeploy left stuck mid-send are paused by the
// backend (paused_reason "stuck_in_sending", see _flag_stuck_sends) with a
// stuck_send record saying whether the step's email went out. The backend has
// already arranged for Resume to do the right thing; this explains which.
export const STUCK_SENDING_REASON = "stuck_in_sending";

export function stuckSendNote(stuckSend) {
  if (stuckSend?.email_status === "sent") {
    return "The email went out before the interruption, so Resume continues with the next step.";
  }
  return "There's no record of the email going out, so Resume sends it. Cancel stops the sequence for this contact.";
}
